export enum LicenseOrder {
  Core = 1,
  Premium = 2,
  BDM = 3,
}
